export default __webpack_public_path__ + "static/media/te-ppe-02.be2b0ecf.png";